import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import AddBlockMenu from 'src/pages/Dashboard/System/Pages/components/AddBlockMenu';
import { PageBlockType } from 'src/interfaces/PageBlock';

interface BlockListInsertDividerProps {
  canAddColumns?: boolean;
  disabledTypes?: Partial<Record<PageBlockType, boolean>>;
  disabledTitles?: Partial<Record<PageBlockType, string>>;
  onAdd: (type: PageBlockType, columnCount?: 2 | 3 | 4) => void;
}

export default function BlockListInsertDivider({
  canAddColumns = false,
  disabledTypes = {},
  disabledTitles = {},
  onAdd,
}: BlockListInsertDividerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        py: 0.75,
        my: 0.25,
      }}
      data-testid="block-list-insert-divider"
    >
      <Divider sx={{ flex: 1 }} />
      <AddBlockMenu
        canAddColumns={canAddColumns}
        disabledTypes={disabledTypes}
        disabledTitles={disabledTitles}
        onAdd={onAdd}
        buttonSize="small"
        buttonVariant="text"
        showButtonIcon={false}
      />
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
}
